
import { Modal } from '../../../components/commons/modal/Modal';

interface Prop {
    onCloseModal: () => void; 
    title:string 
    children:React.ReactNode
    actions?:React.ReactNode
    onSubmit?: React.FormEventHandler<HTMLFormElement>;
    showLine?:boolean
}

export const SIMPLDialog = (props:Prop)=>{
    const {onCloseModal,title,children,actions,showLine,onSubmit}=props
    
    const handleOnSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        if (onSubmit) {
            onSubmit(event);
        }
    };
    
    return (
        <Modal
            title={title}
            onClose={onCloseModal}
            actions={actions}
            onSubmit={handleOnSubmit}
            showLine={showLine}
        >
              {children}   
        </Modal>
    );
};
